export const ALLOWED_VALUES_QUESTIONS = {
    POSTALCODE: {
        titles: ["PostalCode"]
    }
};

export const ALLOWED_VALUES_CONTROL_TYPE_LABEL = "File Upload";
export const ALLOWED_VALUES_CONTROL_TYPE_HINT = "Responses are validated against the uploaded file, not mapped options.";
export const INPUT_TEXT_BOX_SLUG = "input-text-box";

const normalizeTitle = (value) => (value || "").trim().toUpperCase();

export const requiresAllowedValuesUpload = (title) => {
    const normalized = normalizeTitle(title);
    if (!normalized) return false;

    return Object.values(ALLOWED_VALUES_QUESTIONS).some((config) =>
        (config.titles || []).some((allowedTitle) => normalizeTitle(allowedTitle) === normalized)
    );
};

export const showAllowedValuesUpload = (title, requiresAllowedValuesUploadFlag = false) =>
    requiresAllowedValuesUploadFlag || requiresAllowedValuesUpload(title);

export const getDisplayControlType = (controlTypeName, isAllowedValuesQuestion) =>
    isAllowedValuesQuestion ? ALLOWED_VALUES_CONTROL_TYPE_LABEL : (controlTypeName || "");

export const findControlTypeIdBySlug = (controlTypes, slug) => {
    const match = (controlTypes || []).find((row) => row.slug === slug);
    return match?.id ?? null;
};

export const resolveInputTextBoxControlTypeId = (controlTypes) =>
    findControlTypeIdBySlug(controlTypes, INPUT_TEXT_BOX_SLUG);

export const appendFormFields = (formData, payload) => {
    Object.keys(payload).forEach((key) => {
        const value = payload[key];
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
        } else {
            formData.append(key, value);
        }
    });
};

export const buildQuestionFormData = (payload, file) => {
    const formData = new FormData();
    appendFormFields(formData, payload);
    if (file) {
        formData.append("allowedValuesFile", file);
    }
    return formData;
};

